import type { IconName } from '../icons';
import { Icon } from './Icon';

// Chips (02 filter · reason chips · classification chips): 999 radius, ≥44px, selected = primary.

export function Chip(props: { label: string; selected?: boolean; icon?: IconName; count?: number; onClick?: () => void; testId?: string; role?: 'tab' | 'button' }) {
  return (
    <button
      type="button"
      role={props.role}
      aria-selected={props.role === 'tab' ? props.selected === true : undefined}
      aria-pressed={props.role === 'tab' ? undefined : props.selected}
      className={`chip ${props.selected ? 'chip-active' : ''}`}
      onClick={props.onClick}
      data-testid={props.testId}
    >
      {props.icon ? <Icon name={props.icon} /> : null}
      {props.label}
      {props.count !== undefined ? <span className="chip-count">{props.count}</span> : null}
    </button>
  );
}

export interface FilterOption<K extends string> {
  key: K;
  label: string;
  count?: number;
}

export function FilterChips<K extends string>(props: { options: FilterOption<K>[]; value: K; onChange: (key: K) => void }) {
  return (
    <div className="chips chips-filter" role="tablist">
      {props.options.map((opt) => (
        <Chip key={opt.key} role="tab" label={opt.label} count={opt.count} selected={opt.key === props.value} onClick={() => props.onChange(opt.key)} />
      ))}
    </div>
  );
}

// On / off chip (present / absent, enabled / disabled). Large enough for a gloved thumb.
export function ToggleChip(props: { label: string; on: boolean; onToggle: (on: boolean) => void; testId?: string }) {
  return (
    <button type="button" className={`chip ${props.on ? 'chip-active' : ''}`} aria-pressed={props.on} onClick={() => props.onToggle(!props.on)} data-testid={props.testId}>
      {props.on ? <Icon name="check" /> : null}
      {props.label}
    </button>
  );
}
